/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const collectionChallengeItemSchema = z.object({
  id: z.number(),
  challengeId: z.number(),
  group: z.string().nullable(),
  sortOrder: z.number(),
  title: z.string(),
  slug: z.string(),
  type: z.string(),
  definition: z.string().optional(),
  cefrLevel: z.string(),
  difficulty: z.number(),
  videoCount: z.number().optional(),
});

export type ICollectionChallengeItem = z.infer<typeof collectionChallengeItemSchema>;

export const listCollectionChallengesResponseDataSchema = z.array(collectionChallengeItemSchema);

export type IListCollectionChallengesResponseData = z.infer<
  typeof listCollectionChallengesResponseDataSchema
>;

export const listCollectionChallengesResponseSchema = createApiResponseSchema(
  listCollectionChallengesResponseDataSchema,
) as z.ZodSchema<IAPI<IListCollectionChallengesResponseData>>;

export type IListCollectionChallengesResponse = IAPI<IListCollectionChallengesResponseData>;
